import { render } from "./ImageField.vue?vue&type=template&id=70d2db9c&scoped=true"
import script from "./ImageField.vue?vue&type=script&lang=js"
export * from "./ImageField.vue?vue&type=script&lang=js"

import "./ImageField.vue?vue&type=style&index=0&id=70d2db9c&scoped=true&lang=scss"

import exportComponent from "/Users/shuaqq/Desktop/jysports/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d2db9c"]])

export default __exports__